import { render, staticRenderFns } from "./AppBillboard.vue?vue&type=template&id=56a33d12&scoped=true&"
import script from "./AppBillboard.vue?vue&type=script&lang=js&"
export * from "./AppBillboard.vue?vue&type=script&lang=js&"
import style0 from "./AppBillboard.vue?vue&type=style&index=0&id=56a33d12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a33d12",
  null
  
)

export default component.exports